import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  standalone: true,
  name: 'tmwDecimal',
})
export default class TmwDecimalPipe implements PipeTransform {
  transform(value: any): string {
    // ⚠️ FIX: Vérifier null/undefined SANS considérer 0 comme falsy
    if (value === null || value === undefined || value === '') return '0';
    return parseFloat(value.toString()).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}
